export default __webpack_public_path__ + "static/media/front-hand.13fecb14.svg";